import { defineMessages } from 'react-intl';

export default defineMessages({
    headerText: {
        id: 'ml.agent.quoteandbind.ho.additionalInfoToQuote.Additional Info',
        defaultMessage: 'Additional Info'
    },
    showAnimalExclusionWarningMessage: {
        id: 'ml.agent.quoteandbind.ho.additionalInfoToQuote.We will require an Animal Liability Exclusion to be included on your policy. Additional details will be included on your quote.',
        defaultMessage: 'We will require an Animal Liability Exclusion to be included on your policy. Please provide the additional details below:',
    },
    continueText: {
        id: 'ml.agent.quoteandbind.ho.additionalInfoToQuote.We\'ll review your claim information next',
        defaultMessage: 'We\'ll review your {claimInformation} next'
    },
    claimInformation: {
        id: 'ml.agent.quoteandbind.ho.additionalInfoToQuote.claim information',
        defaultMessage: 'claim information'
    },
    helptext:{
        id: 'ml.agent.quoteandbind.ho.additionalInfoToQuote.What does this mean',
        defaultMessage: 'What does this mean?'
    },
    helptextMap:{
        id: 'ml.agent.quoteandbind.ho.additionalInfoToQuote.newPolicySameLocation',
        defaultMessage: 'You are purchasing a new policy for the same location but with different type of coverage.  For example, purchasing the home you were previously renting.'
    },
    somethingWentWrong: {
        id:'ml.agent.quoteandbind.ho.additionalInfoToQuote.Something went wrong during this process.  Please try again.',
        defaultMessage:"Something went wrong during this process.  Please try again."
    },
    InvalidInsuranceProviderForBookRoll: {
        id: 'ml.agent.quoteandbind.ho.additionalInfoToQuote.InvalidInsuranceProviderForBookRoll',
        defaultMessage: 'Prior Insurance Provider is not valid for the Book Roll Type combination'
    }
});